import session from "@/services/auth/session";
import { useAuthStore } from "@/stores";

export default (to) => {
    
    if(!to.meta?.middleware?.includes('auth') && !to.meta?.middleware?.includes('company')) return true;
    
    const authStore = useAuthStore();
    const user = authStore.user;
    const company = authStore.company;

    if(to.meta?.middleware?.includes('company') && !company)
        return { name: 'dashboard' };

    if(!authStore.isLoggedIn && ['auth.register', 'auth.login'].includes(to.name))
        return true;

    if(!authStore.isLoggedIn) 
        return { name: 'auth.login' };

    session().check();

    if(!user) {
        authStore.logout();
        return { name: 'auth.login' };
    }

    if(!['admin'].includes(user.role) && !user.is_completed && to.name !== 'onboarding')
        return { name: 'onboarding' };

    if(['admin'].includes(user.role) && user.is_completed && to.name === 'onboarding')
        return { name: 'dashboard' };

    if(to.meta?.roles?.length &&!to.meta?.roles?.includes(user.role)){
        return { name: 'dashboard' };
    }


    return true;
}